import Link, { Props as LinkProps } from 'components/Link';
import * as React from 'react';

import './styles/NavItem.scss';

/**
 * ```example
 * <ul>
 *   <NavItem href="#">
 *     NavItem
 *   </NavItem>
 *   <NavItem href="#">
 *     NavItem
 *   </NavItem>
 *   <NavItem href="#">
 *     NavItem
 *   </NavItem>
 * </ul>
 * ```
 *
 *
 * # TODO
 * * Reconcile with similar paradigms throughout app
 */

export type Props = {
  children: React.ReactNode;
} & LinkProps;

class NavItem extends React.Component<Props> {
  render() {
    return (
      <li className="NavItem">
        <Link
          {...this.props}
          onlyActiveOnIndex
          className="NavItem-link"
          activeClassName="NavItem-link--active"
          eventElementName="NavItem-link">
          {this.props.children}
        </Link>
      </li>
    );
  }
}

export default NavItem;
